const state = {
    iMost: {},
    snapshot: {},
    keycompanymetrics: {},
    valuationmetrics: {},
    financialsummary: {},
    revenue: {},
    revenuemillions: {},
    annualrevenue: {},
    yoygrowth: {},
    bsDrive: {},
    incomestatementmillions: {},
    costassumptions: {},
    balancesheet: {},
    analysis: {},
    revenuechildchartdata:{}
};

const actions = {
    
};

const getters = {
    iMost: (state) => state.iMost,
    snapshot: (state) => state.snapshot,
    keycompanymetrics: (state) => state.keycompanymetrics,
    valuationmetrics: (state) => state.valuationmetrics,
    financialsummary: (state) => state.financialsummary,
    revenue: (state) => state.revenue,
    revenuemillions: (state) => state.revenuemillions,
    annualrevenue: (state) => state.annualrevenue,
    yoygrowth: (state) => state.yoygrowth,
    bsDrive: (state) => state.bsDrive,
    incomestatementmillions: (state) => state.incomestatementmillions,
    costassumptions: (state) => state.costassumptions,
    balancesheet: (state) => state.balancesheet,
    analysis: (state) => state.analysis,
    revenuechildchartdata: (state) => state.revenuechildchartdata,
};

const mutations = {
    SET_IMOST: (state, iMost) => {
        state.iMost = iMost;
    },
    SET_SNAPSHOT: (state, snapshot) => {
        state.snapshot = snapshot;
    },
    SET_KEYCOMPANYMETRICS: (state,keycompanymetrics) => {
        sessionStorage.setItem("keycompanymetrics", JSON.stringify(keycompanymetrics));
        state.keycompanymetrics = keycompanymetrics;
    },
    SET_FINANCIALSUMMARY: (state,financialsummary) => {
        state.financialsummary = financialsummary;
    },
    SET_VALUATIONMETRICS: (state,valuationmetrics) => {
        sessionStorage.setItem("valuationmetrics", JSON.stringify(valuationmetrics));
        state.valuationmetrics = valuationmetrics;
    },
    SET_REVENUEMILLIONS: (state,revenuemillions) => {
        state.revenuemillions = revenuemillions;
    },
    SET_ANNUALREVENUE: (state,annualrevenue) => {
        sessionStorage.setItem("annualrevenue", JSON.stringify(annualrevenue));
        state.annualrevenue = annualrevenue;
    },
    SET_YOYGROWTH: (state,yoygrowth) => {
        sessionStorage.setItem("yoygrowth", JSON.stringify(yoygrowth));
        state.yoygrowth = yoygrowth;
    },
    SET_INCOMESTATEMENTMILLIONS: (state,incomestatementmillions) => {
        sessionStorage.setItem("incomestatementmillions", JSON.stringify(incomestatementmillions));
        state.incomestatementmillions = incomestatementmillions;
    },
    SET_COSTASSUMPTIONS: (state,costassumptions) => {
        sessionStorage.setItem("costassumptions", JSON.stringify(costassumptions));
        state.costassumptions = costassumptions;
    },
    SET_BALANCESHEET: (state,balancesheet) => {
        sessionStorage.setItem("balancesheet", JSON.stringify(balancesheet));
        state.balancesheet = balancesheet;
    },
    SET_ANALYSIS: (state,analysis) => {
        sessionStorage.setItem("analysis", JSON.stringify(analysis));
        state.analysis = analysis;
    },
    SET_REVENUECHILDCHARTDATA: (state,revenuechildchartdata) => {
        let filterData = revenuechildchartdata.filter(function (item) {
            return (item.name != 'unallocated');
        });
        sessionStorage.setItem("revenuechildchartdata", JSON.stringify(filterData));
        state.revenuechildchartdata = filterData;
    },
    updatedData: (state,obj) => {
        // console.log('updates mutation-=-=',obj);
        state[obj.key] = obj.data;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}